export const STORAGE_KEY = 'colors/storage';
